module.exports = __webpack_public_path__ + "img/dlt_kind_7.c21276e9.png";